import { IGetSDUIFilteredComponentsResponse } from "@faire/web-api/indigofair/data/IGetSDUIFilteredComponentsResponse";
import { Column } from "@faire/web/slate/Layout";
import React from "react";

import { SDUIComponentRenderer } from "@faire/retailer/components/SDUI/__internal__/SDUIComponentRenderer/SDUIComponentRenderer";
import { SDUISectionInstanceRendererProps } from "@faire/retailer/components/SDUI/__internal__/types";
import { SDUIFilterRowRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/FilterBar/SDUIFilterRowRenderer";
import { SDUIFilterablePaginatedSectionFilterRowLoadingSkeleton } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/LoadingSkeleton/SDUIFilterablePaginatedSectionFilterRowLoadingSkeleton";
import { SDUIFilterablePaginatedSectionGridLoadingSkeleton } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/LoadingSkeleton/SDUIFilterablePaginatedSectionGridLoadingSkeleton";

export const FilterablePaginatedSectionComponentsColumnRenderer: React.FC<
  Omit<SDUISectionInstanceRendererProps, "section"> & {
    filteredComponentsData: IGetSDUIFilteredComponentsResponse | undefined;
    isFilterLoading: boolean;
    isFilteredComponentsFetching: boolean;
  }
> = ({
  filteredComponentsData,
  isFilterLoading,
  isFilteredComponentsFetching,
  componentRenderers,
  sectionLoggingData,
}) => {
  return (
    <Column style={{ width: "100%", minWidth: 0 }}>
      {filteredComponentsData?.components ? (
        filteredComponentsData?.components
          ?.filter((component) => component.filter_bar_component)
          .map((component) => {
            return (
              <SDUIFilterRowRenderer
                key={component.id}
                component={component}
                sectionLoggingParams={sectionLoggingData}
                isFilterLoading={isFilterLoading}
              />
            );
          })
      ) : (
        <SDUIFilterablePaginatedSectionFilterRowLoadingSkeleton />
      )}

      {!isFilteredComponentsFetching ? (
        filteredComponentsData?.components
          ?.filter((component) => !component.filter_bar_component)
          .map((component) => (
            <SDUIComponentRenderer
              key={component.id}
              component={component}
              componentRenderers={componentRenderers}
              sectionLoggingParams={sectionLoggingData}
              isPrimaryContent={!!component.is_required_for_interactivity}
            />
          ))
      ) : (
        <SDUIFilterablePaginatedSectionGridLoadingSkeleton />
      )}
    </Column>
  );
};
